/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout';
var gradeRouter = [
  // {
  //   path: '/workbenchgarde',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',  
  //       component: () => import('@/views/gov/workbenchgarde'),
  //       meta: { title: '工作台', icon: 'nav_workbench', roles: ['schoolgrade','schoolclazz'] },
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   name: 'gradeatareport',
  //   component: Layout,
  //   meta: { title: '数据分析', icon: 'nav_data', roles: ['schoolgrade','schoolclazz'] },
  //   children: [
  //     {
  //       path: 'indexvision',
  //       component: () => import('@/views/school/report/indexvision'),
  //       meta: { title: '视力分析', },
  //     },
  //     {
  //       path: 'indexillness',
  //       component: () => import('@/views/school/report/indexillness'),
  //       meta: { title: '常见病分析', },
  //     }
  //   ]
  // },

  // {
  //   path: '/grade/functionally',
  //   name: 'functionallys',
  //   component: Layout,
  //   hidden:true,
  //   meta: { title: '功能分类', icon: 'nav_functive', roles: ['schoolgrade','schoolclazz'] },
  //   children: [
  //     // {
  //     //   path: 'grade',
  //     //   component: () => import('@/views/school/information/grade'),
  //     //   meta: { title: '班级信息管理',  }
  //     // },
  //     // {
  //     //   path: 'questionnairestatistics',
  //     //   component: () => import('@/views/school/information/questionnairestatistics'),
  //     //   meta: { title: '调查问卷统计', }
  //     // },
  //     // {
  //     //   path: "management",
  //     //   component: () => import("@/views/school/checks/clazz/management"),
  //     //   meta: { title: "晨午检上报", roles: ['schoolclazz'] }
  //     // },
  //     // {
  //     //   path: "attendanceManage",
  //     //   component: () => import("@/views/school/checks/clazz/attendanceManage"),
  //     //   meta: { title: "考勤管理" , roles: ['schoolclazz']}
  //     // },

  //   ]
  // },

  // {
  //   path: '/school/file',
  //   component: Layout,
  //   meta: { roles: ['schoolgrade'] },
  //   children: [
  //     {
  //       path: '',
  //       name: 'file',
  //       component: () => import('@/views/school/file'),
  //       meta: { title: '学生档案管理', icon: 'ope' },
  //     }
  //   ]
  // },
  // {
  //   path: '/school/roport',
  //   name: 'roport',
  //   component: Layout,
  //   meta: { title: '数据分析', icon: 'report', roles: ['schoolgrade'] },
  //   children: [
  //     {
  //       path: 'grade',
  //       component: () => import('@/views/school/report/grade'),
  //       meta: { title: '年级数据分析' }
  //     },
  //     {
  //       path: 'class',
  //       component: () => import('@/views/school/report/class'),
  //       meta: { title: '班级数据分析' }
  //     }
  //   ]
  // },
  // {
  //   path: '/school/personal',
  //   component: Layout,
  //   meta: { roles: ['schoolgrade'] },
  //   children: [
  //     {
  //       path: '',
  //       name: 'personal',
  //       component: () => import('@/views/gov/personal'),
  //       meta: { title: '个案数据分析', icon: 'people' },
  //     }
  //   ]
  // },
];
export default gradeRouter;